<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M14 12V9.5A4.5 4.5 0 109.5 14H12v4H9.5a4.5 4.5 0 104.5 4.5V20h4v2.5a4.5 4.5 0 104.5-4.5H20v-4h2.5A4.5 4.5 0 1018 9.5V12h-4zm-2 0V9.5A2.5 2.5 0 109.5 12H12zm10.5-5A2.5 2.5 0 0020 9.5V12h2.5a2.5 2.5 0 000-5zM20 22.5V20h2.5a2.5 2.5 0 11-2.5 2.5zM9.5 25a2.5 2.5 0 002.5-2.5V20H9.5a2.5 2.5 0 000 5zm4.5-7v-4h4v4h-4z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'webSystemCommand'
}
</script>
